// apparently every library expects the node `global` object
Object.assign(window, { global: window });

export default window;
